import { createAction, handleActions } from 'redux-actions';
import testFeatures from '../constants/testFeatures';
import Agent from '../api/Agent';
import { handleError } from './user';

export const setGlobalFeatures = createAction('SET_GLOBAL_FEATURES');
export const setGlobalFeaturesMap = createAction('SET_GLOBAL_FEATURES_MAP');
export const setIsFetching = createAction('SET_IS_FETCHING');
export const setRateIncreaseOptions = createAction('SET_RATE_INCREASE_OPTIONS');
export const setSelectedRateIncrease = createAction('SET_SELECTED_RATE_INCREASE');

const initialState = {
	globalFeatures: [],
	globalFeaturesMap: null,
	isFetching: null,
	rateIncreaseOptions: [],
	selectedRateIncrease: ''
};

export default handleActions(
	{
		SET_GLOBAL_FEATURES: (state, action) => ({ ...state, globalFeatures: action.payload }),
		SET_GLOBAL_FEATURES_MAP: (state, action) => ({ ...state, globalFeaturesMap: action.payload }),
		SET_IS_FETCHING: (state, action) => ({ ...state, isFetching: action.payload }),
		SET_RATE_INCREASE_OPTIONS: (state, action) => ({ ...state, rateIncreaseOptions: action.payload }),
		SET_SELECTED_RATE_INCREASE: (state, action) => ({ ...state, selectedRateIncrease: action.payload })
	},
	initialState
);

export const getGlobalFeatures = (fn) => (dispatch) => {
	dispatch(setIsFetching(true));

	Agent.getGlobalFeatures()
		.then((response) => {
			if (response.ok) {
				dispatch(setGlobalFeatures(response.data));
				dispatch(setGlobalFeaturesMap(createMapFromArrayForFeatures(response.data)));
			} else {
				dispatch(handleError(response));
			}
			dispatch(setIsFetching(false));
			if (fn) fn();
		})
		.catch(() => {
			dispatch(setGlobalFeatures([]));
			dispatch(setIsFetching(false));
			if (fn) fn();
		});
};

export const getRateIncreaseOptions = (locationID) => (dispatch) => {
	Agent.getRateIncreaseOptions(locationID).then((response) => {
		if (response.ok) {
			if (response.data) {
				dispatch(setRateIncreaseOptions(response.data));
			}
		} else {
			dispatch(handleError(response));
		}
	});
};

function createMapFromArrayForFeatures(featureArray) {
	const featureMap = {};

	for (let i = 0; i < featureArray.length; i++) {
		featureMap[featureArray[i].name] = featureArray[i];
	}

	return featureMap;
}

export const isFeatureActive = (featureName, features = []) => {
	const feature = features && features.find((feature) => feature.name == featureName);
	return feature && !feature.is_deleted;
};

/**
 * @deprecated
 * This function is currently in the process of being replaced. While it should
 * still be used, any new uses should include the logic to handle the switch to
 * the corresponding enterprise-setting. More details on this can be found in
 * the crn-enterprise-settings folder's README.
 */
export const isOrgFeatureActive = (featureName, features) => {
	const feature = features && features.find((feature) => feature.feature_name == featureName);
	return feature && feature.feature_status;
};

export const getFilteredReqByFieldType = (reqCustomFields, features) => {
	const filteredFields = reqCustomFields.filter((f) => {
		let allowed = true;
		if (f.field_type === 'role' && !isFeatureActive(testFeatures.USER_REQUIREMENT_FIELD_TYPE_ROLE, features)) {
			allowed = false;
		} else if (f.field_type === 'state' && !isFeatureActive(testFeatures.USER_REQUIREMENT_FIELD_TYPE_STATE, features)) {
			allowed = false;
		} else if (
			f.field_type === 'checkbox' &&
			!isFeatureActive(testFeatures.USER_REQUIREMENT_FIELD_TYPE_CHECKBOX, features)
		) {
			allowed = false;
		}
		return allowed;
	});

	return filteredFields;
};

export const getFilteredReqByDataType = (reqCustomFields, features) => {
	const filteredFields = reqCustomFields.filter((f) => {
		let allowed = true;
		if (f.data_type === 'role' && !isFeatureActive(testFeatures.USER_REQUIREMENT_FIELD_TYPE_ROLE, features)) {
			allowed = false;
		} else if (f.data_type === 'state' && !isFeatureActive(testFeatures.USER_REQUIREMENT_FIELD_TYPE_STATE, features)) {
			allowed = false;
		} else if (
			f.data_type === 'checkbox' &&
			!isFeatureActive(testFeatures.USER_REQUIREMENT_FIELD_TYPE_CHECKBOX, features)
		) {
			allowed = false;
		}
		return allowed;
	});

	return filteredFields;
};
